import React from "react";
import { makeStyles } from 'tss-react/mui';
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Checkbox, ListItemText, Box, Typography, Tooltip } from "@mui/material";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles()((theme) => {
	return {
		select: {
			"& li": {
				padding: "0px",
				height: "auto"
			},
			padding: "0px",
		},
		menuItem: {
			padding: '8px 16px',
			minHeight: '40px',
			'&:hover': {
				backgroundColor: 'rgba(0, 0, 0, 0.04)',
			}
		},
		connectionContainer: {
			display: 'flex',
			alignItems: 'center',
			gap: '12px',
			width: '100%',
		},
		connectionName: {
			flex: 1,
			fontSize: '14px',
			fontWeight: 400,
		},
		statusIndicator: {
			width: '10px',
			height: '10px',
			borderRadius: '50%',
			transition: 'all 0.2s ease-in-out',
			cursor: 'pointer',
			'&:hover': {
				transform: 'scale(1.2)',
				boxShadow: '0 0 8px rgba(0, 0, 0, 0.2)',
			}
		}
	}
});

// Função para obter a cor do status
const getStatusColor = (status) => {
	switch (status) {
		case 'CONNECTED':
			return '#4caf50'; // Verde
		case 'qrcode':
			return '#ff9800'; // Amarelo/Laranja
		case 'DISCONNECTED':
			return '#f44336'; // Vermelho
		default:
			return '#9e9e9e'; // Cinza padrão
	}
};

// Função para obter o texto do status
const getStatusText = (status) => {
	switch (status) {
		case 'CONNECTED':
			return 'Conectado';
		case 'qrcode':
			return 'QR Code';
		case 'DISCONNECTED':
			return 'Desconectado';
		default:
			return 'Desconhecido';
	}
};

const TicketsConnectionSelect = ({
	size,
	userConnections,
	selectedConnectionIds = [],
	onChange,
}) => {

	const { classes } = useStyles();

	const handleChange = e => {
		onChange(e.target.value);
	};

	// Adiciona opção "Sem Conexão" se necessário
	const connectionsWithNoConnection = [
		{ id: 'no_connection', name: 'Sem Conexão', status: 'DISCONNECTED' },
		...(userConnections || [])
	];

	return (
		<FormControl margin="dense" sx={{ marginBottom: '0px', marginTop: '0px' }} fullWidth size="small">
			<Select
				multiple
				displayEmpty
				variant="outlined"
				value={selectedConnectionIds}
				onChange={handleChange}
				MenuProps={{
					classes: { paper: classes.select },
					anchorOrigin: {
						vertical: "bottom",
						horizontal: "left",
					},
					transformOrigin: {
						vertical: "top",
						horizontal: "left",
					},
					getcontentanchorel: null,
				}}
				renderValue={() => "Conexões"}
			>
				{connectionsWithNoConnection?.length > 0 &&
					connectionsWithNoConnection.map(connection => {
						const statusColor = getStatusColor(connection.status);
						const statusText = getStatusText(connection.status);

						return (
							<MenuItem
								dense
								key={connection.id}
								value={connection.id}
								className={classes.menuItem}
							>
								<Checkbox
									size="small"
									color="primary"
									checked={selectedConnectionIds.indexOf(connection.id) > -1}
								/>
								<ListItemText
									primary={
										<Box className={classes.connectionContainer}>
											{connection?.id != 'no_connection' && <Tooltip
												title={statusText}
												placement="top"
												arrow
												enterDelay={300}
												leaveDelay={100}
											>
												<Box
													className={classes.statusIndicator}
													sx={{
														backgroundColor: statusColor,
													}}
												/>
											</Tooltip>}
											<Typography className={classes.connectionName}>
												{connection.name}
											</Typography>
										</Box>
									}
								/>
							</MenuItem>
						);
					})
				}
			</Select>
		</FormControl>
	);
};

export default TicketsConnectionSelect;